import { ButtonModule } from "primeng/button";
import { ClinicGlobalStore } from '../../store/clinic-global.store';
import { ClinicSiteFooterComponent } from "../clinic-site-footer/clinic-site-footer.component";
import { ClinicSiteHeaderComponent } from "../clinic-site-header/clinic-site-header.component";

import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ChangeDetectionStrategy } from '@angular/core';
import { CountBadgeComponent, NonProdBannerComponent } from '@web/csl-lib-components';
import { Drawer, DrawerModule } from 'primeng/drawer';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import { GlobalStore } from '@web/csl-lib-store';
import { PassportForCareConstants } from '@web/csl-lib-constants';
import { FeatureFlagService, HelpService } from '@web/csl-lib-services';
import { HomeBreadcrumbComponent } from './home-breadcrumb/home-breadcrumb.component';
import { ProgressBarModule } from "primeng/progressbar";
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from "primeng/table";
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    ButtonModule,
    ClinicSiteFooterComponent,
    ClinicSiteHeaderComponent,
    CountBadgeComponent,
    Drawer,
    DrawerModule,
    FormsModule,
    HomeBreadcrumbComponent,
    ProgressBarModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    SelectButtonModule,
    TableModule,
    ToastModule,
    NonProdBannerComponent
],
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.css',
  providers: [GlobalStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeLayoutComponent {
  /* Store */

  clinicGlobalStore = inject(ClinicGlobalStore);

  /* Services */

  /* Member Vars */

  readonly globalStore = inject(GlobalStore);
  featureFlagService = inject(FeatureFlagService);
  helpService = inject(HelpService);
  showHelp = computed(() => this.helpService.helpContent() !== null);

  pfcLogoUrl = PassportForCareConstants.LOGO_SYMBOL_URL;

  /* Lifecycle Hooks */

  /* Event Handlers */

  onHelpDrawerHide() {
    this.helpService.clearHelp();
  }

  /* Instance Methods */
  protected readonly environment = environment;
}


